import { render, staticRenderFns } from "./NotificationPagesList.vue?vue&type=template&id=e0cd8bfa&"
import script from "./NotificationPagesList.vue?vue&type=script&lang=js&"
export * from "./NotificationPagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports